module.exports = __webpack_public_path__ + "img/protect-card.0eccbcc7.png";